import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO/SEO';

const CONTACT_EMAIL = 'liaqatapril@gmail.com';

const Terms: React.FC = () => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Terms of Service - travelbaba786',
    url: 'https://travelbaba786.com/terms',
    description: 'Terms of Service for travelbaba786, an independent travel and visa information directory.',
  };

  return (
    <>
      <SEO
        title="Terms of Service - travelbaba786"
        description="Terms of Service for travelbaba786. Read how you may use our visa directory, photo tools, and travel information."
        keywords="terms of service, travelbaba786 terms, website terms"
        url="https://travelbaba786.com/terms"
        structuredData={structuredData}
      />
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900 dark:text-white">
          Terms of Service
        </h1>
        <p className="text-gray-500 dark:text-gray-400 mb-10">Last updated: August 15, 2026</p>

        <div className="space-y-8 text-gray-700 dark:text-gray-300 leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing travelbaba786.com, you agree to these Terms of Service. If you do not agree, please do not use the website.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">2. What This Website Is</h2>
            <p>
              travelbaba786 is an independent information directory. We publish links to official government visa, ETA, and travel portals, plus travel guides and a passport photo editor. We are not a government agency and we do not process visa applications, collect visa fees, or guarantee visa approval.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">3. Accuracy of Information</h2>
            <p>
              Visa rules and government websites change often. We try to keep links and guides current, but you must confirm requirements on the official government website before you travel or apply. We are not responsible for outdated links, rejected applications, or travel disruptions.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">4. Photo Editor Tools</h2>
            <p>
              The photo editor is provided as a convenience. You are responsible for checking that the final photo meets the destination country’s official size and background rules before you submit it.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">5. Acceptable Use</h2>
            <p>
              You may not use this website to break the law, upload harmful files, scrape content in a way that overloads our servers, or impersonate travelbaba786.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">6. Intellectual Property</h2>
            <p>
              Website design, original articles, and branding belong to travelbaba786 unless otherwise noted. Government logos and portal content belong to their respective governments.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">7. Privacy</h2>
            <p>
              How we handle information is explained in our{' '}
              <Link to="/privacy" className="text-blue-600 dark:text-blue-400 font-semibold">
                Privacy Policy
              </Link>
              .
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">8. Limitation of Liability</h2>
            <p>
              The website is provided “as is”. To the fullest extent allowed by law, travelbaba786 is not liable for losses arising from use of this site, including visa decisions, travel plans, or photo submissions.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">9. Contact</h2>
            <p>
              Questions about these terms:{' '}
              <a href={`mailto:${CONTACT_EMAIL}`} className="text-blue-600 dark:text-blue-400 font-semibold">
                {CONTACT_EMAIL}
              </a>
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default Terms;
